import axiosApiClient from 'core/clients/axiosApiClient';
import { ActivityItemService } from 'core/services/activityItem.abstract.service';
import { LtiEvaluationModel } from 'core/models/elements/evaluations/ltiEvaluation.model';
import { LtiQuestionModel } from 'core/models/elements/questions/ltiQuestion.model';
import { LtiQuestionAnswerModel } from 'core/models/elements/answers/ltiQuestionAnswer.model';
import { LtiQuestionAnswerCommand } from 'core/commands/elements/answers/ltiQuestionAnswer.command';

export class LtiQuestionService extends ActivityItemService {
  constructor(env) {
    super(env);
  }

  async answer(activitySessionId, activityItemId, ltiQuestionAnswer) {
    if (!(ltiQuestionAnswer instanceof LtiQuestionAnswerModel)) {
      throw new TypeError(
        'The answer must be an instance of class "LtiQuestionAnswerModel"',
      );
    }
    const ltiQuestionAnswerCommand = new LtiQuestionAnswerCommand(
      ltiQuestionAnswer,
    );
    return await super.answer(
      activitySessionId,
      activityItemId,
      ltiQuestionAnswerCommand,
    );
  }

  evaluate(ltiQuestion, ltiQuestionAnswer) {
    if (!(ltiQuestion instanceof LtiQuestionModel)) {
      throw new TypeError(
        'The question must be an instance of class "LtiQuestionModel"',
      );
    }
    if (!(ltiQuestionAnswer instanceof LtiQuestionAnswerModel)) {
      throw new TypeError(
        'The answer must be an instance of class "LtiQuestionAnswerModel"',
      );
    }

    const evaluation = new LtiEvaluationModel(ltiQuestion);
    const ltiQuestionObject = ltiQuestionAnswer.ltiResults;

    // FIXME: This is probably wrong
    if (ltiQuestionObject) {
      evaluation.rawScore = ltiQuestionObject.ScaledScore ?? 0;
      evaluation.maxScore = 1;
      evaluation.scaledScore = ltiQuestionObject.ScaledScore ?? 0;
      evaluation.isCorrect = ltiQuestionObject.IsSuccessful ?? false;
    }

    evaluation.isAnswerComplete = !!ltiQuestionAnswer.ltiResults;

    return evaluation;
  }

  prepareAnswerAndEvaluation(item, ltiResults) {
    const itemToEvaluate = JSON.parse(JSON.stringify(item));
    
    const answer = new LtiQuestionAnswerModel({
      quizItemId: itemToEvaluate.id,
      ltiResults: ltiResults,
    });

    if (ltiResults) {
      answer.scaledScore = ltiResults.ScaledScore ?? 0;
      answer.isSuccessful = ltiResults.IsSuccessful ?? false;
    }

    console.log('ltiQuestion.service answer', answer);

    const evaluation = this.evaluate(item, answer);

    console.log('ltiQuestion.service evaluation', evaluation);

    return {
      answer,
      evaluation,
    };
  }

  async launchLti(activitySessionId, questionId, messageType) {
    return await axiosApiClient.post(
      `${this.apiUrl}/api/lti/launch?activitySessionId=${activitySessionId}&questionId=${questionId}&messageType=${messageType}`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  }
}
